import { Component, ViewChild } from '@angular/core';
import { QrCodeGuidelinesPdfComponent } from '../qr-code-guidelines-pdf/qr-code-guidelines-pdf.component';
@Component({
  selector: 'app-driver-qrcode-info',
  templateUrl: './driver-qrcode-info.component.html',
  styleUrls: ['./driver-qrcode-info.component.scss'],
})
export class DriverQrcodeInfoComponent {
  @ViewChild('pdfComponent') pdfComponent: QrCodeGuidelinesPdfComponent;

  downloadPDF() {
    this.pdfComponent.downloadPDF();
  }
}
